import store from "../store";

const ALLOWED_WHEN_LOCKED = new Set([
  "/agency/billing",
  "/logout",
  "/profile",
  "/pages/account/settings",
  "/pages/account/billing",
]);

/**
 * Soft-lock: when platform payment grace has expired, keep users on Agency Billing
 * so they can update payment (Stripe Customer Portal).
 */
export default async function platformBillingLock({ next, to }) {
  const role = store.getters["profile/role"];
  if (role !== "agency_admin") {
    return next();
  }

  if (!store.state.agencyBilling?.loaded && !store.state.agencyBilling?.loading) {
    await store.dispatch("agencyBilling/refresh").catch(() => null);
  }

  if (!store.getters["agencyBilling/showPaymentLock"]) {
    return next();
  }

  const path = to.path || "";
  if (ALLOWED_WHEN_LOCKED.has(path) || path.startsWith("/agency/billing")) {
    return next();
  }

  return next({ path: "/agency/billing", replace: true });
}
